import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { generatePath } from 'react-router-dom'
import { CartBundle } from '@typesApp/Product'
import { connectorActionModuleSelector } from '@redux/slices/connectorSlice'
import { useEnvironment } from './useEnvironment'

type UseCartReturn = {
  isCart: boolean
  refreshCart: () => void
  navigateToCart: () => void
  fetchCartBundle: () => Promise<CartBundle>
}

export const useCart = (): UseCartReturn => {
  const { cartPath } = useEnvironment()
  const actionModule = useSelector(connectorActionModuleSelector)
  const isCart = window.location.pathname.includes(cartPath)

  const refreshCart = useCallback(async () => {
    try {
      actionModule?.refreshCart()
    } catch (error) {
      console.warn(error)
    }
  }, [actionModule])

  const navigateToCart = useCallback(async () => {
    try {
      if (typeof actionModule?.navigateToCart === 'function') {
        actionModule?.navigateToCart()
      } else {
        window.location.href = generatePath(`${cartPath}`)
      }
    } catch (error) {
      console.warn(error)
    }
  }, [actionModule, cartPath])

  const fetchCartBundle = useCallback(() => {
    if (typeof actionModule?.getCartItemDetails !== 'function')
      throw new Error('Bad configuration, getCartItemDetails hook missing')
    return actionModule?.getCartItemDetails()
  }, [actionModule])

  return {
    isCart,
    refreshCart,
    navigateToCart,
    fetchCartBundle,
  }
}
